module.exports = __webpack_public_path__ + "img/qur.696bbca9.png";